import template from './terms.html';
import './terms.scss';

export default {
  template,
};



// WEBPACK FOOTER //
// ./src/app/screens/guest/screens/terms/terms.component.js